import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../Assets/Logo.jpg";
import "../CSS/Nav.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="Navbar">
      <div className="nav-top-content">
        <div>
          <img className="nav-logo-image" src={logo}></img>
        </div>
      </div>
      <div className={`nav-items ${isOpen && "open"}`}>
        <Link to="/">Home</Link>
        <Link to="/about">About Us</Link>
        <Link to="/infra">Infrastructure</Link>
        <Link to="/products">Products</Link>
        <Link to="/contact">Contact Us</Link>
      </div>
      <div
        className={`nav-toggle ${isOpen && "open"}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="bar"></div>
      </div>
    </div>
  );
};

export default Navbar;
